export const GET_DAILY_CHALLENGE_FOR_EDITOR =
  'course/GET_DAILY_CHALLENGE_FOR_EDITOR';
export const UPDATE_DAILY_CHALLENGE_BY_ID = 'course/UPDATE_DAILY_CHALLENGE_BY_ID';
export const UPDATE_DAILY_CHALLENGE_STATUS =
  'course/UPDATE_DAILY_CHALLENGE_STATUS';

export const GET_CURRENT_COURSE = 'course/GET_CURRENT_COURSE';
export const UPDATE_COURSE_BY_ID = 'course/UPDATE_COURSE_BY_ID';
export const UPDATE_COURSE_STATUS = 'course/UPDATE_COURSE_STATUS';
export const CREATE_COURSE_MODULE = 'course/CREATE_COURSE_MODULE';
export const REMOVE_COURSE_MODULE_BY_ID = 'course/REMOVE_COURSE_MODULE_BY_ID';
export const UPDATE_COURSE_MODULE_BY_ID = 'course/UPDATE_COURSE_MODULE_BY_ID';
export const REORDER_COURSE_LESSONS = 'course/REODER_COURSE_LESSONS';
export const REORDER_COURSE_MODULES = 'course/REORDER_COURSE_MODULES';
